import { resolver } from "@msuite/ui/libs/form";
import { useTranslation } from "@msuite/ui/localization";
import { useDataTableContext } from "@msuite/ui/table";
import { toast } from "@msuite/ui/toast";
import { partnershipReportReferenceFormSchema } from "@msuite/utils/schemas";
import type { PartnerTimelineInvoiceTrackingItem } from "@msuite/utils/types";
import { useForm } from "react-hook-form";
import { client } from "@/hono";
import { useAuth } from "@/hooks/use-auth";

/** Props Interface */
interface PartnerTimelineInvoiceTrackingInvoiceNumberProps {
	item: PartnerTimelineInvoiceTrackingItem;
}

export function PartnerTimelineInvoiceTrackingInvoiceNumber({
	item,
}: PartnerTimelineInvoiceTrackingInvoiceNumberProps) {
	/** Hooks */
	const { t } = useTranslation();
	const { refetch } = useDataTableContext();
	const { organization } = useAuth();

	/** Form */
	const methods = useForm({
		defaultValues: {
			invoiceNumber: item.invoiceNumber || "",
		},
		resolver: resolver(partnershipReportReferenceFormSchema),
	});

	/** Function */
	async function handleOnChange() {
		try {
			const invoiceNumber = methods.getValues("invoiceNumber");
			await client.organizations[":orgId"].partnerships[":partnershipId"].timeline.report.reference[
				":referenceId"
			].$patch({
				param: {
					orgId: organization!.id!,
					partnershipId: item.partnershipId,
					referenceId: item.id,
				},
				json: {
					invoiceNumber,
				},
			});
			await refetch?.();
		} catch (error) {
			console.error(error);
			toast.error(t("general.something_went_wrong"));
		}
	}

	/** Render */
	return (
		<input
			className="absolute inset-0 focus:border focus:border-accent-500 px-3 tabular-nums"
			placeholder={t("placeholders.invoice_number")}
			{...methods.register("invoiceNumber")}
			onBlur={async (e) => {
				e.stopPropagation();
				e.preventDefault();
				await handleOnChange();
			}}
		/>
	);
}
